export default "__VITE_ASSET__ebcDSw2A__"